// Copyright (c) 2026 Dyna Robotics, Inc. All rights reserved.
// Dyna Robotics Proprietary and Confidential.
// Unauthorized copying, use, or distribution is prohibited.
// SPDX-License-Identifier: LicenseRef-Dyna-Internal

/**
 * A status as a coloured pill.
 *
 * The value is the server's own enum — ACTIVE, SCRAPPED, DRAFT, PUBLISHED — and it is shown
 * verbatim rather than translated. These are the words that appear in the API, in the CSV
 * exports and in the audit log, and a quality engineer comparing a screen against an export
 * should not have to map one vocabulary onto another.
 *
 * The colour is derived from the value, so a status the client has never heard of still
 * renders — as a neutral pill rather than as nothing.
 */
export function StatusBadge({ status }: { status: string }) {
  return <span className={`badge badge-${status.toLowerCase()}`}>{status}</span>;
}
